var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4i9ddd479a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.839216 0 0 0 0 0.709804 0 0 0 0 0.427451 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-825 -72) translate(825 72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M20.444 8.32c.013.183.013.365.013.547 0 5.56-4.124 11.966-11.663 11.966-2.322 0-4.48-.69-6.294-1.888.33.04.647.052.99.052 1.916 0 3.68-.664 5.089-1.796-1.802-.04-3.313-1.25-3.833-2.917.254.039.508.065.774.065.368 0 .736-.052 1.079-.143-1.878-.39-3.287-2.084-3.287-4.128v-.052c.546.313 1.18.508 1.853.534-1.104-.755-1.827-2.044-1.827-3.503 0-.781.203-1.497.558-2.122 2.018 2.552 5.05 4.219 8.452 4.4-.064-.312-.102-.637-.102-.963 0-2.317 1.828-4.205 4.1-4.205 1.18 0 2.245.507 2.994 1.328.926-.182 1.815-.534 2.602-1.016-.305.977-.952 1.797-1.802 2.318.824-.091 1.624-.326 2.36-.651-.558.833-1.256 1.575-2.056 2.174z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7c702f10.svg";
export { ForwardRef as ReactComponent };